import * as React from "react";

import LowTimeIndicator from "images/low-time-indicator.png";
import StudentChoiceContentForLowTimeModal from "./StudentChoiceContentForLowTimeModal";

type TLowTimeModalProps = {
  resetCaseUrl: string;
  programName: string;
  timeOnCase: string;
  userId: number;
  newCourseBuilder2Enabled: boolean;
  documentSetListForStudentChoiceCases?: TDocumentSetListForStudentChoiceCases;
  documentId?: number;
};

const LowTimeModal = ({
  resetCaseUrl,
  programName,
  timeOnCase,
  userId,
  documentSetListForStudentChoiceCases,
  documentId,
  newCourseBuilder2Enabled = false,
}: TLowTimeModalProps) => {
  const handleModalClose = () => {
    document.dispatchEvent(new Event("acknowledgeLowTime"));
  };

  return (
    <div className="gen-modal">
      <div className="low-time-modal--container">
        <div className="low-time-modal--header-container">
          <div className="low-time-modal--title">
            Case completed with low time
          </div>
          <div className="low-time-modal--subtitle">
            We noticed you completed the case in under 25% of the recommended
            time.
          </div>
        </div>
        <div className="low-time-modal--warning-text-container">
          <div className="low-time-modal--image-container">
            <img src={LowTimeIndicator} alt="low time indicator" />
          </div>
          <p className="low-time-modal--warning-text">
            Faculty can see this status on their reports.
          </p>
          <div className="low-time-modal--learn-more-link-container">
            <a
              href="https://aquifer.org/resources-tools/reporting-for-students/#1748451003797-741fdebd-489b"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more
            </a>{" "}
            about how time is calculated.
          </div>
        </div>
        <StudentChoiceContentForLowTimeModal
          newCourseBuilder2Enabled={newCourseBuilder2Enabled}
          documentSetListForStudentChoiceCases={
            documentSetListForStudentChoiceCases
          }
          onAcknowledgeLowTime={handleModalClose}
          onResetCase={handleModalClose}
          documentId={documentId}
          resetCaseUrl={resetCaseUrl}
          userId={userId}
          programName={programName}
          timeOnCase={timeOnCase}
        />
        {newCourseBuilder2Enabled ? null : (
          <div className="low-time-modal--cta-button-container">
            <a
              href="#"
              className="ref-btn"
              aria-label="Acknowledge low time"
              onClick={() => {
                handleModalClose();
              }}
            >
              <span>ok, I understand</span>
            </a>
            <button
              type="button"
              className="ref-btn"
              data-controller="reset-case"
              data-reset-case-target="resetCaseButton"
              data-action="click->reset-case#reset"
              data-reset-url={resetCaseUrl}
              data-user-id={userId}
              data-program={programName}
              data-time-on-case={timeOnCase}
              aria-label="reset case"
            >
              <span>Reset case to restart my time</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(LowTimeModal);
